import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

const FinalCta = () => {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-[1120px] mx-auto px-6">
        <div className="relative overflow-hidden rounded-3xl border border-[#2A2A2A]">
          <div className="absolute inset-0" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?q=80&w=1600&auto=format&fit=crop)", backgroundSize: "cover", backgroundPosition: "center" }} data-testid="cta-bg-image" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(13,13,13,0.72) 0%, rgba(13,13,13,0.88) 100%)" }} />
          <div className="relative max-w-[760px] mx-auto px-6 py-20 md:py-24 text-center">
            <p className="text-[13px] font-semibold tracking-[0.18em] uppercase text-[#FF7A2F]">{t("cta.eyebrow")}</p>
            <h2 className="mt-4 text-[34px] md:text-[46px] font-bold tracking-tight text-white leading-[1.1]">
              {t("cta.titlePlain")}<span className="text-[#FF5C00]">{t("cta.titleAccent")}</span>
            </h2>
            <p className="mt-5 text-[17px] text-neutral-300">{t("cta.subtitle")}</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-9">
              <Link to="/boka" className="group flex items-center gap-2 bg-[#1A8A4A] hover:bg-[#20A458] text-white text-[15px] font-semibold px-7 py-3.5 rounded-xl transition-colors">
                {t("cta.primary")}<ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link to="/signin?role=talent" className="bg-[#181818]/80 hover:bg-[#232326] border border-[#2A2A2A] text-white text-[15px] font-semibold px-7 py-3.5 rounded-xl transition-colors backdrop-blur-sm">{t("cta.secondary")}</Link>
            </div>
            <p className="mt-6 text-[14px] text-neutral-400">{t("cta.note")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
